module.exports = __webpack_public_path__ + "img/lightbulb-off.e71ed04c.svg";